import { createUseStyles } from 'react-jss';
import { breakpoints } from '@insurancemenu/imenu-components-lib/dist/utils';
import BackgroundImage from '../../assets/images/404-background.png';

const styles = {
  page: {
    padding: '2.4rem 6.4rem',
    background: `url(${BackgroundImage}) no-repeat center center fixed`,
    backgroundSize: 'cover',
    minHeight: '100vh',
    [breakpoints.md.down]: {
      padding: '5rem',
      background: `url(${BackgroundImage}) no-repeat 65% center fixed`,
    },
  },
  pageContent: {
    paddingLeft: '9.6rem',
    paddingTop: '17.8rem',

    [breakpoints.md.down]: {
      paddingLeft: 0,
      paddingTop: '5rem',
    },
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
